import { useTranslation } from 'next-i18next'

import { css } from '@emotion/react'

import GoogleButton from '@/components/common/GoogleButton'
import AppleButton from '@/components/common/AppleButton'
import { Grid } from '@/styles/grid'

import Title from '@/components/common/Title'
import { fade } from '@/styles/global'
import { colors, vars } from '@/styles/theme'
import { mediaColumns } from '@/styles/grid'
import { mediaDown, mediaUp } from '@/styles/media'

import ScrollArrow from '@/components/common/ScrollArrow'

function Hero() {
  const { t } = useTranslation('navipay')

  return (
    <section css={styles.container}>
      <Grid>
        <div css={styles.leftColumn}>
          <Title css={[styles.title]} text={t('hero')} primary animated />
          <div css={styles.iconsWrapper}>
            <GoogleButton dark />
            <AppleButton dark />
          </div>
        </div>
        <div css={styles.rightColumn}>
          <img
            src={'https://cdn.naviparking.com/digital_parking/img/navipay.webp'}
            alt={t('imageAlt')}
          />
        </div>
      </Grid>
      <ScrollArrow anchor="park-section" />
    </section>
  )
}

const styles = {
  iconsWrapper: css`
    width: 100%;
    display: flex;
    margin-top: 18px;
    animation: ${fade} 1s both;
    animation-delay: 1s;

    svg,
    img {
      width: 87px;
      height: 31px;
    }

    a:first-of-type {
      margin-inline-end: 20px;
    }

    ${mediaUp('lg')} {
      margin-top: 60px;

      svg,
      img {
        width: 170px;
        height: 58px;
      }

      a:first-of-type {
        margin-inline-end: 40px;
      }
    }
  `,
  leftColumn: css`
    ${mediaColumns({ xs: [12, 0], md: [6, 0] })};
    margin: 10px 0 28px;

    ${mediaUp('md')} {
      margin: 20px 0 60px;
    }

    ${mediaUp('lg')} {
      margin: 20px 0 80px;
    }
  `,
  rightColumn: css`
    ${mediaColumns({ xs: [12, 0], md: [6, 6] })};
    position: relative;
    height: 100%;
    min-height: 159px;
    animation: ${fade} 1s both;
    animation-delay: 0.25s;

    img {
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  `,
  title: css`
    text-align: start;

    ${mediaDown('lg')} {
      font-size: 24px;
      line-height: 1.29;
    }
  `,
  container: css`
    position: relative;
    padding-top: ${vars.headerHeightMobile};
    background-color: ${colors.paleGrey};
    display: flex;
    align-items: center;
    text-align: center;

    ${mediaUp('lg')} {
      padding-top: ${vars.headerHeight};
    }
  `
}

export default Hero
